<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="移库单号" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="出库单号搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="审批状态" prop="state">
                <el-select
                    v-model="form.state"
                    placeholder="选择状态"
                    class="clientc"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="(value,index) in $store.state.state"
                        :key="index"
                        :label="value"
                        :value="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="录单员" prop="entry_staff_id">
                <el-input
                    v-model="form.entry_staff_id"
                    placeholder="录单员搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="移库日期" prop="mvtry_date">
                <el-date-picker
                    v-model="form.mvtry_date"
                    align="right"
                    type="date"
                    placeholder="选择移库日期"
                    value-format="yyyy-MM-dd"
                    class="mvtry_datec"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
            <el-button
                v-if="$_has(add_auth)"
                type="success"
                plain
                round
                @click="addTeam"
                class="temp_add"
                size="medium"
                >添加移库单</el-button
            >
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'DetryBillSearchBarComponent',
    data() {
        return {
            form: {
                state: '',
                name: '',
                entry_staff_id: '',
                mvtry_date: '',
                page: 1,
            },
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        addTeam() {
            this.$emit('addTeam')
        },
    },
    filters: {},
    props: {
        add_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style>
.temp_add {
    float: right;
    margin-bottom: 10px;
}
</style>